export const markdownTextStyles = {
  // dark:prose-invert: typography's default palette is for light backgrounds and overrides
  // the inherited text color, so without it dark-theme markdown is dark gray on dark gray.
  root: "aui-md prose prose-sm max-w-none break-words dark:prose-invert",
};
